import { render, staticRenderFns } from "./examResult.vue?vue&type=template&id=7346ae48&scoped=true"
import script from "./examResult.vue?vue&type=script&lang=js"
export * from "./examResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346ae48",
  null
  
)

export default component.exports